import React from 'react'
import PropTypes from 'prop-types'
import { MdInfo } from 'react-icons/md'
import BoxRounded from '../BoxRounded/BoxRounded'
import Text from '../Text/Text'
import Flex from '../Flex/Flex'
import styles from './boxIndicator.module.scss'

const BoxIndicator = ({
  active,
  smallTitle,
  title,
  updatedAt,
  width,
  height,
  FooterBox,
  margin,
  hasInfo,
  onClickInInfo
}) => {
  return (
    <BoxRounded
      id="indicator"
      active={active}
      width={width}
      height={height}
      margin={margin}
    >
      <Flex flex="1" column justifyContent="space-between">
        {smallTitle && (
          <Text
            size="xs"
            color={active ? 'white' : 'gray'}
            variation="dark"
            font="custom"
            fontWeight="400"
          >
            {smallTitle}
          </Text>
        )}
        {title !== '0' && (
          <Text
            size="lg"
            extraBold
            color={active ? 'white' : 'gray'}
            variation="dark"
          >
            {title}
          </Text>
        )}

        {!FooterBox && updatedAt && (
          <Flex alignItems="center" justifyContent="space-between">
            <Text
              size="xs"
              color={active ? 'white' : 'gray'}
              variation="dark"
              font="custom"
              fontWeight="400"
            >
              {updatedAt}
            </Text>
            {hasInfo && (
              <div className={styles.boxContainer}>
                <MdInfo
                  color={active ? 'white' : '#4d4d4d'}
                  onClick={() => onClickInInfo()}
                  size={20}
                />
              </div>
            )}
          </Flex>
        )}

        {FooterBox && <FooterBox />}
      </Flex>
    </BoxRounded>
  )
}

BoxIndicator.defaultProps = {
  smallTitle: null,
  updatedAt: null,
  onClickInInfo: null,
  active: false,
  width: '258px',
  height: '212px',
  margin: '',
  FooterBox: null,
  hasInfo: null
}

BoxIndicator.propTypes = {
  smallTitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  updatedAt: PropTypes.string,
  onClickInInfo: PropTypes.func,
  width: PropTypes.string,
  height: PropTypes.string,
  margin: PropTypes.string,
  active: PropTypes.bool,
  hasInfo: PropTypes.bool,
  FooterBox: PropTypes.func
}

export default BoxIndicator
